module.exports = __webpack_public_path__ + "static/media/drmario_0.bb6c8c02.png";